import { Theme, alpha } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { UiAlpha } from '../../../styles/ui-alpha';

export const useStyles = makeStyles<Theme>()((theme) => ({
  root: {
    ...theme.mixins.appContainer,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  rootNeutral: {},
  iconCircle: {
    width: 76,
    height: 76,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: alpha(theme.palette.error.main, UiAlpha.Tint),
    color: theme.palette.error.main,
  },
  iconCircleNeutral: {
    backgroundColor: alpha(theme.palette.text.secondary, UiAlpha.Tint),
    color: theme.palette.text.secondary,
  },
  statusCode: {
    color: theme.palette.error.main,
  },
  statusCodeNeutral: {
    color: theme.palette.text.secondary,
  },
  description: {
    maxWidth: 540,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));
